import styled, { css } from 'styled-components';
import Card from 'features/shared/ui/Card';
import {
  OlympiadStatus,
  olympiadStatusBgColor,
  olympiadStatusTextColor,
} from '../../models/Olympiad';

const textEllipsis = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const statusBadgeStyles = (status: OlympiadStatus) => css`
  background-color: ${olympiadStatusBgColor[status]};
  color: ${olympiadStatusTextColor[status]};
`;

export const OlympiadCardWrap = styled(Card)<{ $clickable?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const CardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const CardHeader = styled(CardTopRow)`
  min-width: 0;
`;

export const CardTitleWrap = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  gap: 8px;
  min-width: 0;
  color: var(--font-color);
`;

export const CardTitle = styled.div`
  ${textEllipsis}
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  min-width: 0;
`;

export const OlympiadStatusBadge = styled.div<{ $status?: OlympiadStatus | string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }

  ${({ $status }) => $status && statusBadgeStyles($status as OlympiadStatus)}
`;

export const MinistryBadgeWrap = styled.div`
  flex-shrink: 0;
  margin-left: auto;
`;

export const MinistryBadge = styled(OlympiadStatusBadge)`
  background-color: var(--black-5);
  color: var(--font-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  cursor: default;
`;

export const DatesStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
`;

export const Dates = styled.div<{ $status?: OlympiadStatus | string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--black-60);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;

  svg {
    flex-shrink: 0;
  }

  ${({ $status }) =>
    $status &&
    css`
      color: ${olympiadStatusTextColor[$status as OlympiadStatus]};
    `}
`;

export const Icon = styled.img`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export const WarningMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--black-60);
  font-size: 12px;
  font-weight: 400;
`;

export const CardActionsGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 12px;
  margin-left: auto;
`;

export const CardActions = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const HintMessage = styled.div`
  color: var(--black-60);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;